import '@low/screen-orientation-polyfill';
import './index.less';

import '@low/config-initial';
import './inject';

import guard from '@low/guard';
import { getPrefixedLogger, labels } from '@ringcentral/rwc-utils/src/rwc-logger';

import appInitialize from '@low/containers/app-initializer';
import '@rwc/utils/desktop-tools/feature-flags/log';
import '@low/dom/inject-app-id';

const DownloadPage = () => require('@down-src/download').default;
const renderDownloadPage = () => appInitialize(DownloadPage);

guard()
    .then(() => {
        renderDownloadPage();
    })
    .catch(e => getPrefixedLogger('vc:download').error(labels.HANDLED_REJECTION, e));
